var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66663 16.0003C2.66663 8.64033 8.63996 2.66699 16 2.66699C23.36 2.66699 29.3333 8.64033 29.3333 16.0003C29.3333 23.3603 23.36 29.3337 16 29.3337C8.63996 29.3337 2.66663 23.3603 2.66663 16.0003ZM21.3333 17.3337H17.3333H14.6666H10.6666C9.93325 17.3337 9.33325 16.7337 9.33325 16.0003C9.33325 15.267 9.93325 14.667 10.6666 14.667H14.6666H17.3333H21.3333C22.0666 14.667 22.6666 15.267 22.6666 16.0003C22.6666 16.7337 22.0666 17.3337 21.3333 17.3337Z",
    fill: "#0055FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.1af9810d2f996ca3126a1f6f69207149.svg";
export { ForwardRef as ReactComponent };